import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/common/Header";
import HomeSlider from "../components/common/HomeSlider";
import HomeTopFilters from "../components/common/HomeTopFilters";
import HomeWishes from "../components/common/HomeWishes";
import SideBar from "../components/common/SideBar";
import ListofAppeals from "../components/DashBoardComp/Appeals";
import ListofCourse from "../components/DashBoardComp/Course";
import ListofAssessment from "../components/DashBoardComp/ListofAssessmenttable";
import ListofDashBoard from "../components/DashBoardComp/ListofDashBoard";
import ListofMentored from "../components/DashBoardComp/ListofMentored";
import ListofRegistrationDashboard from "../components/DashBoardComp/RegistrationDashboard/ListofRegistrationDashboard";
import TicketDetailCourses from "../components/DashBoardComp/Ticket";
import MentoredStudentsBadge from "../components/HomePage/MentoredStudentsBadge";
import UnreadMessagesBadge from "../components/HomePage/UnreadMessagesBadge";
import { invalidateDashboardQueries, useDashboardAllCounts } from "../query/hooks/QueryHooksDashboard";
import { setWidget, unsetWidget } from "../store/actions";
import { TABLE_TIME_FORMAT } from "../utils/Constants";

export const StaticQuickLinks = [
    {
        url_name: "NetSuite",
        url: "https://system.netsuite.com/pages/customerlogin.jsp?country=US",
        status: "static",
        permission: "qlnsview",
    },
    {
        url_name: "Payspace",
        url: "https://identity.yourhcm.com/Account/Login",
        status: "static",
        permission: "qlpsview",
    },
    {
        url_name: "Sharepoint",
        url: "https://cadcorporation.sharepoint.com/sites/AIEGroup",
        status: "static",
        permission: "qlspview",
    },
];

const HomePage = ({ match, history }) => {
    const dispatch = useDispatch();

    // Redux Store Selectors
    const notification = useSelector((state) => state.notification);
    const user = useSelector((state) => state.user);
    const widget = useSelector((state) => state.widget);

    // State Declarations
    const [ariaboolean, setAriaboolean] = useState(false);
    const [quickLinks, setQuickLinks] = useState([...StaticQuickLinks]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isResponded, setIsResponded] = useState(false);
    const [linkUrl, setLinkUrl] = useState("");
    const [linkName, setLinkName] = useState("");
    const [filterIntake, setFilterIntakeState] = useState([]);
    const [filterSchool, setFilterSchoolState] = useState([]);
    const [filterLearningMethod, setFilterLearningMethodState] = useState([]);
    const [globalReset, setGlobalResetState] = useState(false);
    const [filterLecturer, setFilterLecturerState] = useState([]);

    const [isValid, setIsValid] = useState(true);
    const [requiredField, setRequiredField] = useState({ name: false, url: false });

    const {
        data: allCount = {},
        isFetching: isFetchingAllCount,
        dataUpdatedAt: dataUpdatedAtAllCount
    } = useDashboardAllCounts(filterIntake, filterSchool, filterLearningMethod, filterLecturer);

    // Filter setters mapping state schema
    const setFilterIntake = (newValue) => {
        setFilterIntakeState((prev) => ({ ...prev, newValue }));
    };
    const setFilterSchool = (newValue) => {
        setFilterSchoolState((prev) => ({ ...prev, newValue }));
    };
    const setFilterLearningMethod = (newValue) => {
        setFilterLearningMethodState((prev) => ({ ...prev, newValue }));
    };
    const setFilterLecturer = (newValue) => {
        setFilterLecturerState((prev) => ({ ...prev, newValue }));
    };
    const setGlobalReset = (newValue) => {
        setGlobalResetState(newValue);
        // TODO: Delete afterwards. Invalidate everything for now:
        invalidateDashboardQueries();
    };

    // Lifecycle Hook: Set widgets:
    useEffect(() => {
        dispatch(unsetWidget());
        dispatch(setWidget({ status: 2 }));
    }, []);

    const nextClass = () => {
        const timeInStamp = allCount?.nextClassTime * 1000;
        const time = new Date(allCount?.nextClassTime * 1000);
        const now = new Date();
        const nowInSec = now.getTime();
        let milliSeconds = (timeInStamp - nowInSec) > 0 ? (timeInStamp - nowInSec) : 0;
        const min = Math.floor(milliSeconds / 1000 / 60);
        const hour = Math.floor(min / 60);

        if (time.getTime() > now.getTime()) {
            return <div className="next__class__timer ml-2">{`${hour}h ${min > 60 ? min - 60 : min}min`}</div>;
        } else {
            return <span>&nbsp;No classess left today</span>;
        }
    };

    // Read URL params if extracted via fallback routers
    const activeTab = match?.params?.tab || "";

    return (
        <>
            <Header />
            <div className="content-wrapper d-flex flex-wrap">
                <SideBar />
                <div className="sidebar-right">
                    <div>
                        <HomeWishes />
                        <HomeSlider />
                        <HomeTopFilters
                            fetchDetails={{ dataUpdatedAt: dataUpdatedAtAllCount, isFetching: isFetchingAllCount }}
                            setGlobalReset={setGlobalReset}
                            filterIntake={filterIntake}
                            setFilterIntake={setFilterIntake}
                            setFilterSchool={setFilterSchool}
                            setFilterLearningMethod={setFilterLearningMethod}
                            setFilterLecturer={setFilterLecturer}
                        />

                        <div className="admin-home-acc accordion ac_over_none" id="accordionExample">
                            {/* COLLAPSE CARD ONE: VIRTUAL CLASSES */}
                            <div className="card-main">
                                <div className="card-top">
                                    <div className="card-header1" id="headingOne">
                                        <h2 className="mb-0">
                                            <button
                                                className="btn btn-link collapsed"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target="#collapseOne"
                                                aria-expanded={match?.url?.includes("/home/virtualClass") ? "true" : "false"}
                                                aria-controls="collapseOne"
                                                onClick={() =>
                                                    history.push(match?.url?.includes("/home/virtualClass") ? "/home" : "/home/virtualClass/today")
                                                }
                                            >
                                                <div className="title-border-box">
                                                    <i className="fal fa-desktop mr-1"></i> Online Virtual Classes
                                                    <div className="d-flex ml-auto">
                                                        {(allCount?.todayClassCount !== null && allCount?.todayClassCount !== undefined) ||
                                                            (allCount?.nextClassTime !== null && allCount?.nextClassTime !== undefined) ? (
                                                            <>
                                                                <span className="nav-fa-comments" title="Amount of Classes Today">
                                                                    <small className={"notify-count " + (allCount?.todayClassCount > 999 && allCount?.todayClassCount < 100000 ? "four-digit" : allCount?.todayClassCount > 9999 && allCount?.todayClassCount < 1000000 ? "five-digit" : allCount?.todayClassCount > 99 && allCount?.todayClassCount < 1000 ? "three-digit" : "")}>
                                                                        {allCount?.todayClassCount}
                                                                    </small>
                                                                    <i className="fal fa-calendar comments"></i>
                                                                </span>
                                                                {allCount?.nextClassTime !== null && allCount?.nextClassTime !== undefined && user?.role_name?.includes("Lecturer") ? (
                                                                    <div className="next__class__wrapper d-flex align-items-center mx-2">
                                                                        <span>Next Class:</span>
                                                                        <span className="next__class__timer ml-2">{moment(new Date(allCount.nextClassTime * 1000)).format(TABLE_TIME_FORMAT)}</span>
                                                                    </div>
                                                                ) : null}
                                                            </>
                                                        ) : (
                                                            <span className="dashboard-loading"> <i className="fas fa-cog fa-spin"></i></span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="header-status">
                                                    <div className="status-gol card-blue-1">
                                                        <i className="fal fa-chevron-down rotate-icon"></i>
                                                    </div>
                                                </div>
                                            </button>
                                        </h2>
                                    </div>
                                    <div
                                        id="collapseOne"
                                        className={`collapse ${activeTab === "virtualClass" ? "show" : ""}`}
                                        aria-labelledby="headingOne"
                                        data-parent="#accordionExample"
                                    >
                                        <div className="card card-body">
                                            {activeTab === "virtualClass" && (
                                                <ListofDashBoard
                                                    globalReset={globalReset}
                                                    filterLearningMethod={filterLearningMethod}
                                                    filterLecturer={filterLecturer}
                                                    filterSchool={filterSchool}
                                                    filterIntake={filterIntake}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* COLLAPSE CARD TWO: ASSESSMENTS */}
                            <div className="card-main">
                                <div className="card-top">
                                    <div className="card-header1" id="headingTwo">
                                        <h2 className="mb-0">
                                            <button
                                                className="btn btn-link collapsed"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target="#collapseTwo"
                                                aria-expanded={match?.url?.includes("/home/assessment/Today") ? "true" : "false"}
                                                aria-controls="collapseTwo"
                                                onClick={() =>
                                                    history.push(match?.url?.includes("/home/assessment") ? "/home" : "/home/assessment/Today")
                                                }
                                            >
                                                <div className="title-border-box">
                                                    <i className="fal fa-file-alt"></i> Assessments
                                                    <div className="d-flex ml-auto">
                                                        {(allCount?.startToday !== null && allCount?.startToday !== undefined) ||
                                                            (allCount?.markingDueToday !== null && allCount?.markingDueToday !== undefined) ||
                                                            (allCount?.markingOverdue !== null && allCount?.markingOverdue !== undefined) ? (
                                                            <>
                                                                <span className="nav-fa-comments" title="Starts Today">
                                                                    <small className={"notify-count " + (allCount?.startToday > 999 && allCount?.startToday < 100000 ? "four-digit" : allCount?.startToday > 9999 && allCount?.startToday < 1000000 ? "five-digit" : allCount?.startToday > 99 && allCount?.startToday < 1000 ? "three-digit" : "")}>
                                                                        {allCount?.startToday}
                                                                    </small>
                                                                    <i className="fal fa-calendar comments"></i>
                                                                </span>
                                                                <span className="nav-fa-comments ml-3" title="Marking Due Today">
                                                                    <small className={"notify-count " + (allCount?.markingDueToday > 999 && allCount?.markingDueToday < 100000 ? "four-digit" : allCount?.markingDueToday > 9999 && allCount?.markingDueToday < 1000000 ? "five-digit" : allCount?.markingDueToday > 99 && allCount?.markingDueToday < 1000 ? "three-digit" : "")}>
                                                                        {allCount?.markingDueToday}
                                                                    </small>
                                                                    <i className="fal fa-calendar-edit comments"></i>
                                                                </span>
                                                                <span className="nav-fa-comments ml-3" title="Marking Overdue">
                                                                    <small className={"notify-count " + (allCount?.markingOverdue > 999 && allCount?.markingOverdue < 100000 ? "four-digit" : allCount?.markingOverdue > 9999 && allCount?.markingOverdue < 1000000 ? "five-digit" : allCount?.markingOverdue > 99 && allCount?.markingOverdue < 1000 ? "three-digit" : "")}>
                                                                        {allCount?.markingOverdue}
                                                                    </small>
                                                                    <i className="fal fa-calendar-exclamation comments"></i>
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <span className="dashboard-loading"> <i className="fas fa-cog fa-spin"></i></span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="header-status">
                                                    <div className="status-gol card-blue-1">
                                                        <i className="fal fa-chevron-down rotate-icon"></i>
                                                    </div>
                                                </div>
                                            </button>
                                        </h2>
                                    </div>
                                    <div
                                        id="collapseTwo"
                                        className={`collapse ${activeTab === "assessment" ? "show" : ""}`}
                                        aria-labelledby="headingTwo"
                                        data-parent="#accordionExample"
                                    >
                                        <div className="card card-body">
                                            {activeTab === "assessment" && (
                                                <ListofAssessment
                                                    globalReset={globalReset}
                                                    filterLecturer={filterLecturer}
                                                    filterSchool={filterSchool}
                                                    filterLearningMethod={filterLearningMethod}
                                                    filterIntake={filterIntake}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* COLLAPSE CARD THREE: COURSES */}
                            <div className="card-main">
                                <div className="card-top">
                                    <div className="card-header1" id="headingFour">
                                        <h2 className="mb-0">
                                            <button
                                                className="btn btn-link collapsed"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target="#collapseFour"
                                                aria-expanded={match?.url?.includes("/home/courses/In Progress") ? "true" : "false"}
                                                aria-controls="collapseFour"
                                                onClick={() =>
                                                    history.push(match?.url?.includes("/home/courses") ? "/home" : "/home/courses/In Progress")
                                                }
                                            >
                                                <div className="title-border-box">
                                                    <i className="fal fa-book"></i> Courses
                                                    <div className="d-flex ml-auto">
                                                        <UnreadMessagesBadge
                                                            filterIntake={filterIntake}
                                                            filterLearningMethod={filterLearningMethod}
                                                            filterLecturer={filterLecturer}
                                                            filterSchool={filterSchool}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="header-status">
                                                    <div className="status-gol card-blue-1">
                                                        <i className="fal fa-chevron-down rotate-icon"></i>
                                                    </div>
                                                </div>
                                            </button>
                                        </h2>
                                    </div>
                                    <div
                                        id="collapseFour"
                                        className={`card-body1 collapse ${activeTab === "courses" ? "show" : ""}`}
                                        aria-labelledby="headingFour"
                                        data-parent="#accordionExample"
                                    >
                                        <div className="card card-body">
                                            {activeTab === "courses" && (
                                                <ListofCourse
                                                    globalReset={globalReset}
                                                    filterLearningMethod={filterLearningMethod}
                                                    filterLecturer={filterLecturer}
                                                    filterSchool={filterSchool}
                                                    filterIntake={filterIntake}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* COLLAPSE CARD FOUR: APPEALS */}
                            <div className="card-main">
                                <div className="card-top">
                                    <div className="card-header1" id="headingFive">
                                        <h2 className="mb-0">
                                            <button
                                                className="btn btn-link collapsed"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target="#collapseFive"
                                                aria-expanded={match?.url?.includes("/home/appeals/pending") ? "true" : "false"}
                                                aria-controls="collapseFive"
                                                onClick={() =>
                                                    history.push(match?.url?.includes("/home/appeals") ? "/home" : "/home/appeals/pending")
                                                }
                                            >
                                                <div className="title-border-box">
                                                    <i className="fal fa-gavel"></i> Appeals
                                                    <div className="d-flex ml-auto">
                                                        {allCount?.appealPendding !== null && allCount?.appealPendding !== undefined ? (
                                                            <span className="nav-fa-comments" title="Pending Appeals Amount">
                                                                <small className={"notify-count " + (allCount?.appealPendding > 999 && allCount?.appealPendding < 100000 ? "four-digit" : allCount?.appealPendding > 9999 && allCount?.appealPendding < 1000000 ? "five-digit" : allCount?.appealPendding > 99 && allCount?.appealPendding < 1000 ? "three-digit" : "")}>
                                                                    {allCount?.appealPendding}
                                                                </small>
                                                                <i className="fal fa-exclamation comments"></i>
                                                            </span>
                                                        ) : (
                                                            <span className="dashboard-loading"> <i className="fas fa-cog fa-spin"></i></span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="header-status">
                                                    <div className="status-gol card-blue-1">
                                                        <i className="fal fa-chevron-down rotate-icon"></i>
                                                    </div>
                                                </div>
                                            </button>
                                        </h2>
                                    </div>
                                    <div
                                        id="collapseFive"
                                        className={`collapse ${activeTab === "appeals" ? "show" : ""}`}
                                        aria-labelledby="headingFive"
                                        data-parent="#accordionExample"
                                    >
                                        <div className="card card-body">
                                            {activeTab === "appeals" && (
                                                <ListofAppeals
                                                    globalReset={globalReset}
                                                    filterLecturer={filterLecturer}
                                                    filterSchool={filterSchool}
                                                    filterLearningMethod={filterLearningMethod}
                                                    filterIntake={filterIntake}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* COLLAPSE CARD FIVE: TICKETS */}
                            <div className="card-main">
                                <div className="card-top">
                                    <div className="card-header1" id="headingSix">
                                        <h2 className="mb-0">
                                            <button
                                                className="btn btn-link collapsed"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target="#collapseSix"
                                                aria-expanded={match?.url?.includes("/home/tickets/summary") ? "true" : "false"}
                                                aria-controls="collapseSix"
                                                onClick={() =>
                                                    history.push(match?.url?.includes("/home/tickets") ? "/home" : "/home/tickets/summary")
                                                }
                                            >
                                                <div className="title-border-box">
                                                    <i className="fal fa-ticket-alt"></i> Tickets
                                                    <div className="d-flex ml-auto">
                                                        {(allCount?.totalNewTicket !== null && allCount?.totalNewTicket !== undefined) ||
                                                            (allCount?.totalDangerTicket !== null && allCount?.totalDangerTicket !== undefined) ? (
                                                            <>
                                                                <span className="nav-fa-comments" title="New Tickets">
                                                                    <small className={"notify-count " + (allCount?.totalNewTicket > 999 && allCount?.totalNewTicket < 100000 ? "four-digit" : allCount?.totalNewTicket > 9999 && allCount?.totalNewTicket < 1000000 ? "five-digit" : allCount?.totalNewTicket > 99 && allCount?.totalNewTicket < 1000 ? "three-digit" : "")}>
                                                                        {allCount?.totalNewTicket}
                                                                    </small>
                                                                    <i className="fal fa-laptop comments"></i>
                                                                </span>
                                                                <span className="nav-fa-comments ml-3" title="Tickets in Danger Zone">
                                                                    <small className={"notify-count " + (allCount?.totalDangerTicket > 999 && allCount?.totalDangerTicket < 100000 ? "four-digit" : allCount?.totalDangerTicket > 9999 && allCount?.totalDangerTicket < 1000000 ? "five-digit" : allCount?.totalDangerTicket > 99 && allCount?.totalDangerTicket < 1000 ? "three-digit" : "")}>
                                                                        {allCount?.totalDangerTicket}
                                                                    </small>
                                                                    <i className="fal fa-file-exclamation comments"></i>
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <span className="dashboard-loading"> <i className="fas fa-cog fa-spin"></i></span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="header-status">
                                                    <div className="status-gol card-blue-1">
                                                        <i className="fal fa-chevron-down rotate-icon"></i>
                                                    </div>
                                                </div>
                                            </button>
                                        </h2>
                                    </div>
                                    <div
                                        id="collapseSix"
                                        className={`collapse ${activeTab === "tickets" ? "show" : ""}`}
                                        aria-labelledby="headingSix"
                                        data-parent="#accordionExample"
                                    >
                                        <div className="card card-body">
                                            {activeTab === "tickets" && (
                                                <TicketDetailCourses
                                                    globalReset={globalReset}
                                                    filterLearningMethod={filterLearningMethod}
                                                    filterLecturer={filterLecturer}
                                                    filterSchool={filterSchool}
                                                    filterIntake={filterIntake}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* COLLAPSE CARD 6: TICKETS */}
                            <div className="card-main">
                                <div className="card-top">
                                    <div className="card-header1" id="headingThree">
                                        <h2 className="mb-0">
                                            <button
                                                className="btn btn-link collapsed"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target="#collapseThree"
                                                aria-expanded={match.url.includes("/home/mentored/pending_sign_off") ? "true" : "false"}
                                                aria-controls="collapseThree"
                                                onClick={() => history.push(match.url.includes("/home/mentored") ? "/home" : "/home/mentored/pending_sign_off")}
                                            >
                                                <div className={`title-border-box`}>
                                                    <i className="fal fa-users"></i> Students
                                                    <div className="d-flex ml-auto">
                                                        <MentoredStudentsBadge
                                                            filterIntake={filterIntake}
                                                            filterLearningMethod={filterLearningMethod}
                                                            filterLecturer={filterLecturer}
                                                            filterSchool={filterSchool}
                                                        />
                                                    </div>
                                                </div>{" "}
                                                <div className="header-status">
                                                    <div className="status-gol card-blue-1">
                                                        <i className="fal fa-chevron-down rotate-icon"></i>
                                                    </div>
                                                </div>
                                            </button>
                                        </h2>
                                    </div>
                                    <div
                                        id="collapseThree"
                                        className={`collapse ${match.params.tab == "mentored" ? "show" : ""
                                            }  `}
                                        aria-labelledby="headingThree"
                                        data-parent="#accordionExample"
                                    >
                                        <div className="card card-body">
                                            {match.params.tab == "mentored" && (
                                                <ListofMentored
                                                    globalReset={globalReset}
                                                    filterLecturer={filterLecturer}
                                                    filterSchool={filterSchool}
                                                    filterIntake={filterIntake}
                                                    filterLearningMethod={filterLearningMethod}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* COLLAPSE CARD SEVEN: REGISTRATION / RE-REGISTRATION */}
                            <div className="card-main">
                                <div className="card-top">
                                    <div className="card-header1" id="headingEight">
                                        <h2 className="mb-0">
                                            <button
                                                className="btn btn-link collapsed"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target="#collapseEight"
                                                aria-expanded={match?.url?.includes("/home/registration") ? "true" : "false"}
                                                aria-controls="collapseEight"
                                                onClick={() =>
                                                    history.push(match?.url?.includes("/home/registration") ? "/home" : "/home/registration/all")
                                                }
                                            >
                                                <div className="title-border-box">
                                                    <i className="fal fa-sign-in-alt"></i> Registration / Re-Registration
                                                </div>
                                                <div className="header-status">
                                                    <div className="status-gol card-blue-1">
                                                        <i className="fal fa-chevron-down rotate-icon"></i>
                                                    </div>
                                                </div>
                                            </button>
                                        </h2>
                                    </div>
                                    <div
                                        id="collapseEight"
                                        className={`collapse ${activeTab === "registration" ? "show" : ""}`}
                                        aria-labelledby="headingEight"
                                        data-parent="#accordionExample"
                                    >
                                        <div className="card card-body">
                                            {activeTab === "registration" && <ListofRegistrationDashboard />}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HomePage;
